class State {

  constructor() {
    this.processes = [];
  }

  isNot(key) {
    return !this.is(key);
  }

  is(key) {
    if (key === undefined) {
      return this.processes.length > 0;
    }

    return _.includes(this.processes, key);
  }

  start(key) {
    if (!this.is(key)) {
      this.processes.push(key);
    }
  }

  stop(key) {
    if (key === undefined) {
      this.processes.splice(0, this.processes.length);
    } else {
      const index = this.processes.indexOf(key);
      this.processes.splice(index, 1);
    }
  }
}

export default State;



// WEBPACK FOOTER //
// ./src/js/helpers/state.js